<template>
  <!-- TODO figure out what app id should be -->
  <v-app id="score_cards" v-cloak>
    <!-- Breakpoint Debugger: Only visible in development -->
    <div v-if="isDev" class="breakpoint-debugger">
      {{ display.name }} | smAndDown: {{ display.smAndDown }}
    </div>

    <v-main class="vMain app-shell" :class="appShellClass">
      <!-- App bar for site.  Shows on all pages  turned off when in preview mode-->
      <v-card class="pa-0 app-shell__surface" fluid>
        <v-app-bar
          :floating="false"
          elevation="2"
          :collapse="false"
          class="appHeaderBar app-shell__header"
        >
            <!-- App bar image -->
            <template v-slot:image>
              <v-img
                :cover="true"
                src="/AppBarImage.jpg"
                class="appBar--image"
                gradient="to top right, var(--cssAppBarGradient-left), var(--cssAppBarGradient-right) "
              ></v-img>
            </template>

            <!-- Title for app bar -->
            <v-app-bar-title
              @click="routerHome"
              class="text-h6 text-sm-h5 text-md-h4 text-lg-h3 text-xl-h2 font-weight-bold appBar-title appBar-title--brand"
            >
              {{ t("app.name") }}
            </v-app-bar-title>

            <!-- Home button -->
            <v-btn
              class="stdBtn stdBtn--toolbar appBar-navBtn"
              @click="routerHome"
            >
              {{ $t("app.home") }}
            </v-btn>

            <!-- Logout button toggles between logout if user logged in and
        login if no user logged in -->
            <v-btn
              class="stdBtn stdBtn--toolbar appBar-navBtn"
              @click="openLogInLogOutDialog"
              >{{ liloButtonTitle }}</v-btn
            >

            <!-- Register button is only displayed if no user logged in -->
            <v-btn
              v-if="!store.getters['auth/userLoggedIn']"
              @click="openRegisterDialog"
              class="stdBtn stdBtn--toolbar appBar-navBtn"
              >{{ $t("app.register") }}</v-btn
            >

            <!-- Help button -->
            <v-tooltip location="left" open-delay="1000">
              <template v-slot:activator="{ props }">
                <v-icon
                  class="iconButton iconButton-light size-md-xl"
                  v-bind="props"
                  icon="mdi-help-circle-outline"
                  @click="routerHelp"
                  :size="smAndDown ? '20px' : '30px'"
                />
              </template>
              <p class="ttText">{{ $t("app.ttGetHelp") }}</p>
            </v-tooltip>

            <!-- User acount info button only displayed if user logged in
        button icon will be green if use is a subcriber to the site, 
        otherwise icon will be white -->
            <div v-if="store.getters['auth/userLoggedIn']">
              <v-tooltip location="start" open-delay="1000">
                <template v-slot:activator="{ props }">
                  <v-icon
                    class="iconButton iconButton-light"
                    v-bind="props"
                    :class="
                      store.getters['sm/isUserSubscriber']
                        ? 'iconButton-active'
                        : 'iconButton-notActive'
                    "
                    icon="mdi-account-plus-outline"
                    @click="openAccountDialog"
                    :size="smAndDown ? '20px' : '30px'"
                  />
                </template>
                <p class="ttText">{{ t("app.ttUpdateAccountInfo") }}</p>
              </v-tooltip>
            </div>
            <!-- If user is a admin, display admin access icon here -->
            <div v-if="store.getters['auth/userIsAdmin']">
              <init-db-menu></init-db-menu>
            </div>
        </v-app-bar>

        <!-- Other components inserted here -->
        <!-- Router linkes -->
        <div class="app-shell__content">
          <router-view></router-view>

          <!-- Footer for site -->
          <div :class="['app-shell__footer', footerShellClass]">
            <TheStandardRow
              :class="[footerRowClass, 'app-footer-row']"
              :rowLevel="1"
              firstColumnSide="none"
              cardMargin=""
              :firstColumnWidth="0"
              density="compact"
              emphasis="subtle"
            >
              <template v-slot:remainingColumns>
                <v-col cols="12" class="app-footer-row__content">
                  <div class="app-footer-row__links">
                    <v-btn
                      v-for="(link, i) in links"
                      :key="link.name"
                      variant="text"
                      class="stdBtn font-italic text-body-2 app-footer-row__link"
                      :class="smAndDown ? 'mt-2' : 'mt-0'"
                      size="x-small"
                      @click="footerButton(i)"
                    >
                      {{ link.name }}
                    </v-btn>
                  </div>

                  <div
                    class="font-italic text-body-2 app-footer-row__meta"
                    :class="smAndDown ? 'app-footer-row__meta--mobile' : ''"
                  >
                    <div>{{ $t("app.nameTM") }} {{ new Date().getFullYear() }}</div>
                    <div class="app-footer-row__version">v{{ APP_VERSION }}</div>
                  </div>
                </v-col>
              </template>
            </TheStandardRow>
          </div>
        </div>

        <!-- Login dialog, activated by value in auth/store -->
        <login-insert
          v-if="store.getters['auth/showLoginLogOutDialog']"
        ></login-insert>

        <!-- Register dialog, activated by value in auth/store -->
        <register-insert
          v-if="store.getters['auth/showRegisterDialog']"
        ></register-insert>

        <!-- Account update dialog, activated by value in auth/store -->
        <account-insert
          v-if="store.getters['auth/showAccountDialog']"
        ></account-insert>

        <!-- This is the about dialog -->
        <TheStandardDialog
          v-if="store.getters['aboutDialog']"
          :showDialog="store.getters['aboutDialog']"
          :titleText="$t('about.title')"
          insertText="not-used"
          :explanationText="$t('about.text')"
          leftBtnText="not-used"
          :rightBtnText="t('common.close')"
          @right-btn="closeAboutDialog"
        >
        </TheStandardDialog>

        <!-- This is the terms and conditions dialog -->
        <TheStandardDialog
          v-if="store.getters['tAndCDialog']"
          :showDialog="store.getters['tAndCDialog']"
          titleText="Terms and conditions"
          insertText="not-used"
          explanationText="not-used"
          leftBtnText="not-used"
          :rightBtnText="t('common.close')"
          @right-btn="closeTermsDialog"
        >
          <template v-slot:dSlot>
            <!-- Terms and conditions are displayed here if button is clicked -->

            <v-row>
              <v-col cols="12" class="pa-1">
                <the-terms-and-conditions></the-terms-and-conditions>
              </v-col>
            </v-row>
          </template>
        </TheStandardDialog>

        <!-- This is the contact inforation dialog -->
        <TheStandardDialog
          v-if="store.getters['contactInfoDialog']"
          :showDialog="store.getters['contactInfoDialog']"
          :titleText="$t('contactInfo.title')"
          insertText="not-used"
          explanationText="not-used"
          leftBtnText="not-used"
          :rightBtnText="t('common.close')"
          @right-btn="closeContactDialog"
        >
          <template v-slot:dSlot>
            {{ t("contactInfo.text") }}
            <a href="mailto:mikeblomquist57@hotmail.com">{{
              t("contactInfo.email")
            }}</a>
          </template>
        </TheStandardDialog>

        <!-- Snackbar, activated by value in /store -->
        <the-snack-bar></the-snack-bar>

      </v-card>
    </v-main>
  </v-app>
</template>

<script setup>
  import { computed, onMounted, ref, defineAsyncComponent, watch } from "vue";
  import { APP_VERSION } from "./appVersion";
  import TheSnackBar from "./components/reusable/TheSnackBar.vue";
  import TheStandardDialog from "./components/reusable/TheStandardDialog.vue";
  import TheStandardRow from "./components/reusable/TheStandardRow.vue";
  import { inDemoMode } from "../src/components/composables/demoModeHelpers";
  import { useStore } from "vuex";
  import { useRoute, useRouter } from "vue-router";
  import { useI18n } from "vue-i18n";
  import { useDisplay } from "vuetify";

  const InitDbMenu = defineAsyncComponent(() =>
    import("./store/initDatabase/initDbMenu.vue")
  );
  const LoginInsert = defineAsyncComponent(() =>
    import("./components/viewInserts/LoginInsert.vue")
  );
  const RegisterInsert = defineAsyncComponent(() =>
    import("./components/viewInserts/RegisterInsert.vue")
  );
  const AccountInsert = defineAsyncComponent(() =>
    import("./components/viewInserts/AccountInsert.vue")
  );
  const TheTermsAndConditions = defineAsyncComponent(() =>
    import("./components/reusable/TheTermsAndConditions.vue")
  );

  //Load responsive display information
  const display = useDisplay();
  const { smAndDown } = display;
  const isDev = import.meta.env.DEV;
  //Load i18n for working with translations
  let { t } = useI18n({});

  const router = useRouter();
  const route = useRoute();
  const store = useStore();

  const appShellClass = computed(() =>
    route.name === "scoreCard" ? "app-shell--wide" : "app-shell--narrow"
  );

  const footerRowClass = computed(() =>
    route.name === "scoreCard" ? "app-footer-row--full" : "surface-panel"
  );

  const footerShellClass = computed(() =>
    route.name === "scoreCard"
      ? "app-shell__footer--scorecard"
      : "app-shell__footer--reading"
  );

  const liloButtonTitle = computed(() => {
    if (store.state.auth.userLoggedIn) {
      //Return text for login/logout button
      return t("app.logout");
    } else {
      return t("app.login");
    }
  });

  //Open account dialog
  function openAccountDialog() {
    /* Disable function if in demo mode */
    if (inDemoMode(t("demoMode.openAccountInfo"), true)) {
      return;
    }

    store.commit("auth/showAccountDialog");
  }

  //Login button pressed
  function openLogInLogOutDialog() {
    store.commit("auth/showLoginLogOutDialog");
  }

  //register button pressed
  function openRegisterDialog() {
    store.commit("auth/showRegisterDialog");
  }

  //Navigate to home page when Home button pressed
  function routerHome() {
    router.replace({ name: "home" });
  }

  //Navigate to help page when ? icon pressed
  function routerHelp() {
    router.push({ name: "help" });
  }

  /* Handle footer */
  /*links name shows on the button in the footer dialogShow is the name of the store commit that turns on the corrosponding dialog*/
  let links = ref([
    { name: t("app.aboutScoreCards"), dialogShow: "aboutDialogShow" },
    { name: t("app.contactInfo"), dialogShow: "contactInfoDialogShow" },
    { name: t("app.showTandC"), dialogShow: "tAndCDialogShow" },
  ]);

  function footerButton(i) {
    //Get the string value of the store commit that opens the dialog
    store.commit(links.value[i].dialogShow);
  }

  function closeAboutDialog() {
    store.commit("aboutDialogHide");
  }

  function closeTermsDialog() {
    store.commit("tAndCDialogHide");
  }

  function closeContactDialog() {
    store.commit("contactInfoDialogHide");
  }

  watch(
    () => [
      store.getters["auth/authInitialized"],
      store.getters["auth/userLoggedIn"],
    ],
    ([authInitialized, userLoggedIn]) => {
      if (!authInitialized) {
        return;
      }

      if (!userLoggedIn) {
        store.dispatch("resetHomeContext");
      }
    },
    { immediate: true }
  );

  onMounted(async () => {
    //Setup observer to watch for changes in authorized user status
    await store.dispatch("auth/authObserver");
  });
</script>

<style lang="scss">
  //This style cannot be scoped, as it is used by all components
  //Import main scss file, which imports all other scss files
  //@import "./sass/main.scss";

  [v-cloak] {
    display: none;
  }

  .vMain {
    background: var(--cssBackground-shell);
    min-height: 100vh;
  }

  .app-shell {
    --appShellFrameWidth: min(100%, var(--cssContentReadingWidth));

    &--wide {
      --appShellFrameWidth: min(100%, var(--cssContentMaxWidth));
    }

    &__surface {
      background: transparent;
      box-shadow: none;
      border: 0;
      border-radius: 0;
    }

    &__header {
      padding-inline: var(--cssSpace-3);
    }

    &__footer {
      width: 100%;
      margin-top: var(--cssSpace-2);
      padding: 0;
      background: transparent;
    }
  }

  .appHeaderBar {
    width: 100% !important;
    padding-inline: 0;

    .v-toolbar__content {
      width: var(--appShellFrameWidth);
      margin: 0 auto;
      padding-inline: var(--cssSpace-2);
      align-items: center;
      border-radius: var(--cssRadius-md);
      overflow: hidden;
    }
  }

  .appBar-title {
    margin-left: 0;
    padding-left: var(--cssSpace-4);
    padding-right: var(--cssSpace-3);
    text-align: left;
    color: var(--cssText-light);
    cursor: pointer;
    font-variant: all-small-caps;
  }

  .appBar-title--brand {
    display: flex;
    align-items: center;
    min-height: 100%;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 1.05;
  }

  .appBar-navBtn {
    font-variant-caps: all-small-caps;
    font-size: clamp(0.95rem, 0.84rem + 0.3vw, 1.15rem) !important;
    line-height: 1;
    align-self: center;
    margin-top: 0;
    margin-bottom: 0;
  }

  .breakpoint-debugger {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    background: var(--color-surface-debug);
    color: var(--color-text-inverse);
    padding: 0.25rem 0.5rem;
    border-radius: var(--cssRadius-sm);
    font-size: 0.75rem;
    z-index: 9999;
    pointer-events: none;
    font-family: monospace;
    box-shadow: 0 2px 4px var(--color-overlay-debug-shadow);
  }

  .app-footer-row {
    margin-block: 0;
  }

  .app-footer-row--full {
    width: 100%;
    margin: 0 auto;
  }

  .app-footer-row__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--cssSpace-3);
  }

  .app-footer-row__links {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem 0.5rem;
    min-height: 100%;
    padding-left: var(--cssStandardRowPadX);
  }

  .app-footer-row__link {
    min-width: 0;
  }

  .app-footer-row__meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    align-self: flex-start;
    text-align: right;
    padding-right: var(--cssStandardRowPadX);
    padding-block: 0.25rem;
    line-height: 1.2;
    white-space: nowrap;
  }

  .app-footer-row__meta--mobile {
    align-items: center;
    text-align: center;
    width: 100%;
    white-space: normal;
  }

  .app-footer-row__version {
    opacity: 0.8;
  }

  .app-shell__footer--reading {
    padding-inline: var(--cssPagePadX);
  }

  .app-shell__footer--scorecard {
    padding-inline: 0;
  }

  @media (max-width: 959px) {
    .app-shell__footer--reading {
      padding-inline: var(--cssSpace-3);
    }
  }
</style>
